import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import { audioFlowRumContext } from '../../services/audio-flow';

import {
  getDatadogApplicationId,
  getDatadogClientToken,
  getDatadogSite,
  getEnvironment,
  getReleaseTag,
} from '../environment';

const applicationId = getDatadogApplicationId();
const clientToken = getDatadogClientToken();
const site = getDatadogSite();
const env = getEnvironment();
const version = getReleaseTag();

if (applicationId && clientToken && site && env) {
  datadogRum.init({
    applicationId,
    clientToken,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: site as RumInitConfiguration['site'],
    service: 'assessment-frontend-user-monitoring',
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: (event) => {
      if (
        event.type === 'action' &&
        event.action.target?.name === 'zara.audio_flow'
      ) {
        event.context = audioFlowRumContext(event.context);
        const stripQuery = (value: string) => value.split(/[?#]/)[0];
        event.view.url = stripQuery(event.view.url);
        if (event.view.referrer)
          event.view.referrer = stripQuery(event.view.referrer);
      }
      return true;
    },
  });
}
